import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { OktaAuthStateService } from '@okta/okta-angular';
import { AuthState } from '@okta/okta-auth-js';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { filter, map } from 'rxjs';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from './shared/services/loader/loader.service';
import { HttpClient } from '@angular/common/http';
import { ToastService } from './shared/services/toast-service/toast.service';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  showHeaderFooter = true;
  public isAuthenticated$!: Observable<boolean>;
  fromDate: NgbDate;
  toDate: NgbDate;
  loading: boolean = false;
  overlayState: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';

  constructor(
    private readonly router: Router,
    private readonly _oktaStateService: OktaAuthStateService,
    private readonly loaderService: LoaderService,
    private route: ActivatedRoute,
    private http: HttpClient,
    public modalService: NgbModal,
    public toastService: ToastService
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      window.scrollTo(0, 0);
    });
  }

  /**
   * ngOnInit() - Initializes the component.
   */
  ngOnInit(): void {
    // Regular authentication and routing logic
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showHeaderFooter = !event.urlAfterRedirects.startsWith('/acc');
      }
    });

    this.isAuthenticated$ = this._oktaStateService.authState$.pipe(
      filter((authState: AuthState) => !!authState),
      map((authState: AuthState) => authState.isAuthenticated ?? false)
    );

    this.loaderService.loading$.subscribe((loading) => {
      this.loading = loading;
    });

    this.loaderService.overlayState$.subscribe((applying) => {
      this.overlayState = applying;
    });

    // Notify other opened tabs to logout and redirect to home page.
    window.addEventListener('storage', (e) => {
      if (e.key === 'logout-event') {
        this.router.navigate(['/homepage']);
        if (this.modalService.hasOpenModals()) {
          this.modalService.dismissAll();
        }

        // Remove the logout event value from local storage, if available
        if (localStorage.getItem('logout-event')) {
          localStorage.removeItem('logout-event');
        }
      }
    });
  }
}
